// Links still open their exact variant when JavaScript is unavailable.
document.addEventListener('click', (event) => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const swatch = event.target.closest('[data-gallery-card-image]');
  const card = swatch?.closest('[data-gallery-card]');
  if (!card) return;
  const photo = card.querySelector('.ionic-product-card__photo img');
  if (!photo) return;
  event.preventDefault();
  photo.removeAttribute('srcset');
  photo.src = swatch.dataset.galleryCardImage;
  photo.alt = swatch.dataset.galleryCardAlt;
  card.querySelectorAll('.ionic-product-card__photo, .ionic-product-card__info h3 a, .ionic-product-card__choose').forEach(link => {
    link.href = swatch.href;
  });
  card.querySelectorAll('.ionic-product-card__swatch').forEach(link => {
    const selected = link === swatch;
    link.classList.toggle('ionic-product-card__swatch--selected', selected);
    if (selected) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
  });
});
